import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import { Loader2 } from "lucide-react";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { getClientId } from "@/lib/client";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const code = new URLSearchParams(window.location.search).get("code");
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { code, client_id: getClientId() },
          { withCredentials: true }
        );
        toast.success(`Signed in as ${data.user.email}`);
        navigate("/", { state: { googleUser: data.user }, replace: true });
      } catch (e) {
        void e;
        toast.error("Google sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="animate-spin text-[#C0392B]" size={28} />
    </div>
  );
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/wraith-panel-x7" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
